import styles from './HowItWorks.module.css'
import useReveal from '../hooks/useReveal.js'

const STEPS = [
  {
    n: '01',
    title: 'Brief us',
    body: 'Tell us the role, the team and your must-haves — a 15-minute call or an online brief, whichever suits.',
  },
  {
    n: '02',
    title: 'AI shortlists',
    body: 'Our matching engine screens against 40+ signals — skills, seniority, location, salary band — and ranks by fit, not keywords.',
  },
  {
    n: '03',
    title: 'You choose who to meet',
    body: 'A recruiter reviews every shortlist by hand before it reaches your inbox. You interview only the people worth your time.',
  },
  {
    n: '04',
    title: 'We help you close',
    body: 'Reference checks, offer support and onboarding notes — we stay involved until they\u2019ve started.',
  },
]

export default function HowItWorks() {
  const [ref, visible] = useReveal()

  return (
    <section className={styles.section} id="how-it-works">
      <div className="container">
        <div className={styles.header}>
          <h2 className={styles.heading}>From brief to shortlist in four steps</h2>
          <p className={styles.sub}>
            The AI does the screening. A person makes the call. That's the whole model.
          </p>
        </div>

        <ol ref={ref} className={`${styles.list} ${visible ? styles.visible : ''}`}>
          {STEPS.map((step) => (
            <li key={step.n} className={styles.step}>
              <span className={styles.num}>{step.n}</span>
              <div className={styles.stepBody}>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepText}>{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
